export default {
  yAxis: [{
    type: 'category',
    axisLine: {
      show: false //坐标线
    },
    axisTick: {
      show: false //小横线
    },
    axisLabel: {
      color: '#fff', //坐标轴字颜色
      formatter(value) {
        if (value >= 10000) {
          return `${(value / 10000).toLocaleString()}万`;
        } 
        return value.toLocaleString();
        
      },
    },
    data: ['河南', '上海', '湖南', '福建', '广东'],
  }, {
    type: 'category',
    inverse: true,
    axisTick: 'none',
    axisLine: 'none',
    show: true,
    axisLabel: {
      // textStyle: {
      //   color: '#ffffff',
      //   fontSize: '12',
      //   align: 'right'
      // },
      formatter(value) {
        // if (value >= 10000) {
        //   return `${(value / 10000).toLocaleString()}万`;
        // } 
        return value.toLocaleString();
      },
    },
    data: [1269, 963, 942, 653, 596]
  }],
  xAxis: {
    show: false,
  },
  grid: {
    top: '5%',
    right: '15%',
    left: '60',
    bottom: '10' //图表尺寸大小
  },
  series: [{
    /* data: [120, 200, 150, 80, 70, 110, 130], */
    type: 'bar',
    barWidth: '7px',
    // showBackground: true,
    backgroundStyle: {
      color: 'rgba(220, 220, 220, 0.4)',
      barBorderRadius: [30, 30, 30, 30] //圆角大小
    },    
    label: {
      show: true,
      position: 'right', //每一条的数据位置
      color: '#fff'
    },
    itemStyle: {
      normal: {
        color: (params) => {
          const colors = ['#4956ff', '#2d82ff', '#56F1FF', '#FF9B26', '#146CFF'];
          return colors[params.dataIndex];
        }, //每个数据的颜色
        barBorderRadius: [30, 30, 30, 30], //圆角大小
        shadowBlur: 10,
        shadowColor: 'rgba(0, 103, 255, 0.2)',
        shadowOffsetX: -5,
        shadowOffsetY: 5,
      },
    },
    data: [{
      value: 596
    },
    {
      value: 653
    },
    {
      value: 942
    },
    {
      value: 963
    },
    {
      value: 1269
    }]
  }]
};
